import React, { StrictMode, useCallback, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { FaRegCopy } from "react-icons/fa6";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { Tooltip } from "@material-tailwind/react";
import { ColDef } from "ag-grid-community";
import { ParticipantsType } from "../../utils/common";


interface Props {
    participantsData: ParticipantsType[];
}

const ParticipantAGTable = ({ participantsData }: Props) => {
    const [rowData, setRowData] = useState<any[]>([]);
    const [tooltipContent, setTooltipContent] = useState("Click to copy");
    const [copiedLinks, setCopiedLinks] = useState(new Map<string, boolean>());

    const handleCopy = useCallback((link: string) => {
        navigator.clipboard.writeText(link);
        setCopiedLinks(currentMap => {
            const newMap = new Map(currentMap);
            newMap.set(link, true);
            return newMap;
        });
        setTooltipContent("Copied!");
        setTimeout(() => {
            setCopiedLinks(currentMap => {
                const newMap = new Map(currentMap);
                newMap.delete(link);
                return newMap;
            });
            setTooltipContent("Click to copy");
        }, 1000); // Reset copied state after 1.5 seconds
    }, []);

    useEffect(() => {
        const formattedData = participantsData.map((item, index) => {
            if (Array.isArray(item)) {
                return { SNo: index + 1, participant_name: item[1], participant_email: item[2], participant_organization: item[3], role: item[5], participant_link: item[4] };
            }
            return { SNo: "", Name: "", Email: "", Organization: "", Link: "" };
        });

        setRowData(formattedData);
    }, [participantsData]);

    const cellRenderer = useCallback(({ value }: any) => (
        <div className="relative">
            <Tooltip
                content={tooltipContent}
                className="bg-neutral-600 w-fit h-7 text-center p-1 absolute top-full left-0 z-50"
                placement="top"
            >
                <div className="flex items-center">
                    <span className="mr-2 cursor-pointer" onClick={(e) => {
                        handleCopy(value); }}>{value}</span>
                    <FaRegCopy
                        className="cursor-pointer"
                        onClick={() => handleCopy(value)}
                    />
                </div>
            </Tooltip>
        </div>
    ), [handleCopy, tooltipContent]);

    const colDefs: ColDef<ParticipantsType>[] = [
        { field: "participant_name", headerName: "Name", width: 150 },
        { field: "participant_email", headerName: "Email", width: 250 },
        { field: "participant_organization", headerName: "Organization", width: 250 },
        { field: "role", headerName: "Role", width: 150 },
        {
            field: "participant_link",
            headerName: "Link",
            width: 570,
            filter: false,
            cellRenderer
        }
    ];

    const defaultColDef: ColDef = {
        flex: 0,
        filter: true,
        editable: false,
        resizable: true
    };

    return (
        <div className="ag-theme-quartz " style={{ marginTop:"20px", width: "100%", height: "95%" }}>
            <AgGridReact
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                cellSelection={true}
                enableCellTextSelection={true}
            />
        </div>
    );
};

export default ParticipantAGTable;
